import { render } from "./portcta.vue?vue&type=template&id=76471a4f"
import script from "./portcta.vue?vue&type=script&lang=js"
export * from "./portcta.vue?vue&type=script&lang=js"

import "./portcta.vue?vue&type=style&index=0&id=76471a4f&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__